import { COACH_HUMANIZING_IMAGE_QUESTION_ID } from 'constants/cms-survey'
import CoachMatchPhoto from '../coach-photo'
import CoachSurveyResponses, {
  COACH_MATCH_PROMOTION_QUESTION_IDS,
} from '../coach-survey-responses'
import s from './styles.module.css'
import { CoachProps } from 'components/coach-profile/coach-profile-hero'

const CoachMusicAboutMe = ({ coach }: CoachProps) => {
  return (
    <div className={s.container}>
      <div className={s.leftCol}>
        {coach.humanizingImage?.url && (
          <CoachMatchPhoto
            url={coach.humanizingImage?.url}
            alt="HumanizingImage"
            questionId={COACH_HUMANIZING_IMAGE_QUESTION_ID}
          />
        )}
      </div>
      <div className={s.rightCol}>
        <CoachSurveyResponses
          coach={coach}
          responseIds={[
            COACH_MATCH_PROMOTION_QUESTION_IDS.FAVORITE_WORKOUT_MUSIC,
            COACH_MATCH_PROMOTION_QUESTION_IDS.MOST_SURPRISED_TO_LEARN_ABOUT_ME,
          ]}
        />
      </div>
    </div>
  )
}

export default CoachMusicAboutMe
